import { render, staticRenderFns } from "./LocationAttributePopover.vue?vue&type=template&id=29564225"
import script from "./LocationAttributePopover.vue?vue&type=script&lang=js"
export * from "./LocationAttributePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports